"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Slider-Widget.
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {string} options.label Label text
 * @param {number} [options.value=0] Initial value
 * @param {number} [options.min=0] Minimum value
 * @param {number} [options.max=1] Maximum value
 * @param {number} [options.step=0.01] Step between values
 * @param {string} [options.unit] Optional unit string
 * @param {function} options.callback Value change callback
 */
gc.gis.widget.GCSlider = function(options )
{
	gc.gis.widget.GCWidget.call( this, options );

	var self = this;

	this.element_label = jQuery('<label>', {
		'class': 'gc-widget-label',
		text: options.label
	});
	this.element_value = jQuery('<span>', {
		text: options.value + options.unit
	});

	this.element_slider = jQuery('<div>', {
		'class': 'gc-slider'
	});
	this.element_slider.slider({
		min:   options.min   || 0,
		max:   options.max   || 1,
		value: options.value || 0,
		step:  options.step  || 0.01,
		slide: function( event, ui ) {
			options.callback.call( self, ui.value );
			self.element_value.text( ui.value + options.unit);
		},
		change: function( event, ui ) {
			self.element_value.text( ui.value + options.unit);
		}
	});

	this.element_container = jQuery('<div>', {
		'class': 'gc-widget gc-widget-slider'+ (options.className ? ' '+ options.className : '')
	});
	this.element_container.append( this.element_label );
	this.element_container.append( this.element_slider );
	this.element_container.append( this.element_value );
};
gc.gis.widget.GCSlider.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.widget.GCSlider.prototype.getElement = function()
{
	return this.element_container;
};

/**
 * Setzt den aktuellen Wert des Sliders.
 *
 * @public
 * @method
 * @param {number} value
 */
gc.gis.widget.GCSlider.prototype.setValue = function(value )
{
	this.element_slider.slider().slider('option', 'value', value);
};

